import { render } from "./ProviderInput.vue?vue&type=template&id=ffc5c64c"
import script from "./ProviderInput.vue?vue&type=script&lang=js"
export * from "./ProviderInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__